import {
  CREATE_SUB_ACCOUNT_PENDING,
  CREATE_SUB_ACCOUNT_SUCCESS,
  CREATE_SUB_ACCOUNT_FAIL,
  DELETE_SUB_ACCOUNT_PENDING,
  DELETE_SUB_ACCOUNT_SUCCESS,
  DELETE_SUB_ACCOUNT_FAIL,
  RESET_PASSWORD_SUB_ACCOUNT_PENDING,
  RESET_PASSWORD_SUB_ACCOUNT_SUCCESS,
  RESET_PASSWORD_SUB_ACCOUNT_FAIL,
  CHANGE_PASSWORD_SUB_ACCOUNT_PENDING,
  CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS,
  CHANGE_PASSWORD_SUB_ACCOUNT_FAIL,
  SET_SUB_ACCOUNT_LIMIT,
  SET_SUB_ACCOUNTS,
} from "./mutation-types";

export default {
  [CREATE_SUB_ACCOUNT_PENDING](state) {
    state.isCreatingSubAccount = true;
    state.errors.create = null;
  },
  [CREATE_SUB_ACCOUNT_SUCCESS](state, payload) {
    state.isCreatingSubAccount = false;
    state.errors.create = null;
    if (payload && !state.subAccounts.find((acc) => acc.id === payload.id)) {
      state.subAccounts.push(payload);
    }
  },
  [CREATE_SUB_ACCOUNT_FAIL](state, error) {
    state.isCreatingSubAccount = false;
    state.errors.create = error;
  },

  [DELETE_SUB_ACCOUNT_PENDING](state) {
    state.isDeletingSubAccount = true;
    state.errors.delete = null;
  },
  [DELETE_SUB_ACCOUNT_SUCCESS](state, username) {
    state.isDeletingSubAccount = false;
    state.errors.delete = null;
    state.subAccounts = state.subAccounts.filter(
      (acc) => acc.username !== username
    );
  },
  [DELETE_SUB_ACCOUNT_FAIL](state, error) {
    state.isDeletingSubAccount = false;
    state.errors.delete = error;
  },

  [RESET_PASSWORD_SUB_ACCOUNT_PENDING](state) {
    state.isResettingPassword = true;
    state.errors.resetPassword = null;
  },
  [RESET_PASSWORD_SUB_ACCOUNT_SUCCESS](state) {
    state.isResettingPassword = false;
    state.errors.resetPassword = null;
  },
  [RESET_PASSWORD_SUB_ACCOUNT_FAIL](state, error) {
    state.isResettingPassword = false;
    state.errors.resetPassword = error;
  },

  [CHANGE_PASSWORD_SUB_ACCOUNT_PENDING](state) {
    state.isChangingPassword = true;
    state.errors.changePassword = null;
  },
  [CHANGE_PASSWORD_SUB_ACCOUNT_SUCCESS](state) {
    state.isChangingPassword = false;
    state.errors.changePassword = null;
  },
  [CHANGE_PASSWORD_SUB_ACCOUNT_FAIL](state, error) {
    state.isChangingPassword = false;
    state.errors.changePassword = error;
  },

  [SET_SUB_ACCOUNT_LIMIT](state, limit) {
    state.subAccountLimit = limit;
  },
  [SET_SUB_ACCOUNTS](state, accounts) {
    state.subAccounts = accounts || [];
  },
};
